// src/features/auth/pages/RegisterPage.jsx
import React from "react";
import Register from "../components/Register";

const RegisterPage = () => {
  return <Register />;
};

export default RegisterPage;
